import WindPlot from "../wind";
import WeatherPlot from "../weather";
import PressurePlot from "../pressure";
import { getStationData } from "../util";
import Box from "@mui/material/Box";


export default function Walensee ({ forecast }) {

  // Get forecast for this station
  let [vmax, speed, dir, t2m, precip, dursun, twater, qff] = getStationData(forecast, "MUL", "walensee", "QFF_KLO_GVE");

  return (
    <div>
      <title>Walensee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Walensee</h2>
          <h3>Mühlehorn</h3>
          <Box sx={{ overflow: "auto" }}>
            <WindPlot vmax={vmax} speed={speed} dir={dir} />
            <PressurePlot qff={qff} label="Zürich − Genf" label_plus="Bise" label_minus="Westwind" />
            <WeatherPlot t2m={t2m} precip={precip} sun={dursun} twater={twater} />
          </Box>
        </div>
      </div>
    </div>
  );
};
